import React, { useState } from "react";
import { Icon } from "@iconify/react";

const GivenStar = ({ value, setValue }) => {
  const [hoverValue, setHoverValue] = useState(undefined);

  const handleClick = (newValue) => {
    setValue(newValue);
  };

  const handleMouseOver = (newHoverValue) => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  return (
    <div>
      {[1, 2, 3, 4, 5].map((index) => (
        <Icon
          key={index}
          icon={(hoverValue || value) >= index ? "gravity-ui:star-fill" : "ph:star-bold"}
          onClick={() => handleClick(index)}
          onMouseOver={() => handleMouseOver(index)}
          onMouseLeave={handleMouseLeave}
          style={{
            color: "#ffc107",
            cursor: "pointer",
            fontSize: "24px",
          }}
        />
      ))}
    </div>
  );
};

export default GivenStar;
